import {
  PreloadingStrategy,
  Route,
  Router,
  ActivatedRoute,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Entitlement, EntitlementLob, LOB } from '@cigna/chcp/auth/util';
import { ChcpLaunchDarklyFlagKey } from '@cigna/chcp/shared/launch-darkly-util';
import { AppContext } from './model';

export type ChcpPageLayout =
  | 'default' // inner page wrapper with top and bottom padding
  | 'custom' // no inner page wrapper but still top and bottom padding
  | 'customFlush' // no inner page wrapper, flush top and bottom
  | 'customFlushTop'; // no inner page wrapper, flush top only

export type ChcpPageBg = 'default' | 'subtle';

export interface RouteData {
  title?: string;
  breadcrumb?: string;
  analytics?: {
    name: string;
    section: string;
    prop13: string;
    eVar51?: string;
    eVar119?: string;
    eVar173?: string;
    loggedIn?: boolean;
    events?: string;
    /** if async is true analytics data will not be sent automatically on route change, you will need to fire manually from component */
    async?: boolean;
  };
  guards?: {
    entitlements?: Array<Entitlement | EntitlementLob>;
    lob?: LOB[];
    features?: ChcpLaunchDarklyFlagKey[];
    appContext?: AppContext;
  };
  routeCode?: string;
  pageLayout?: ChcpPageLayout;
  pageBg?: ChcpPageBg;
  disableNavigation?: boolean;
  preload?: boolean;
  lazyLoadContent?: string[];
  preloadContent?: string[];
  loadChatData?: boolean;
  loginContext?: 'vic' | 'tableau' | 'default';
}

export interface ChcpRoute extends Route {
  data?: RouteData;
  children?: ChcpRoute[];
}

export declare type ChcpRoutes = ChcpRoute[];

export function deepestActivatedRoute(router: Router): ActivatedRoute | null {
  let route = router.routerState.root.firstChild;

  if (route) {
    while (route.firstChild) {
      route = route.firstChild;
    }
  }

  return route;
}

@Injectable()
export class CustomPreloadingStrategy implements PreloadingStrategy {
  preload(
    route: ChcpRoute,
    load: () => Observable<unknown>,
  ): Observable<unknown> {
    return route.data && route.data.preload ? load() : of(null);
  }
}
